import { useMutation as e } from "@maat/store-hooks";
import { marketingApi as t } from "@maat/api-main";
//#region src/marketing/useRecordMarketingEventMutation.ts
var n = () => e({ mutationFn: (e) => t.recordEvent(e.assetId, e.type, e.placement) });
//#endregion
export { n as useRecordMarketingEventMutation };
